import _regenerator from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = {
  class: "admin-home"
};
var _hoisted_2 = {
  class: "home-left"
};
var _hoisted_3 = {
  class: "home-right"
};
import { onBeforeUnmount, onMounted } from 'vue';
import UserInfo from './Common/UserInfo.vue';
import MessageNotice from '../Common/MessageNotice.vue';
import TodoList from './Common/TodoList.vue';
import AppList from './Common/AppList.vue';
import { getUnRead } from '@/api/home.js';
import { MessagePlugin } from 'tdesign-vue-next';
import { validateNull } from '@/util/validate';
import $Bus from '@/util/bus';
import { NOTIFY_UPDATA_EVENT, SHOW_NOTIFY_EVENT } from '@/const/busEvent.js';
export default {
  __name: 'index',
  setup: function setup(__props) {
    onMounted(function () {
      getUnReadRequset();
      addBusEvent();
    });
    onBeforeUnmount(function () {
      removeBusEvent();
    });
    /**
     * 添加事件监听
     */
    var addBusEvent = function addBusEvent() {
      $Bus.on(NOTIFY_UPDATA_EVENT, getUnReadRequset);
    };
    /**
     * 移除事件监听
     */
    var removeBusEvent = function removeBusEvent() {
      $Bus.off(NOTIFY_UPDATA_EVENT, getUnReadRequset);
    };
    /**
     * 获取未读消息
     */
    var getUnReadRequset = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var res, _res$data, code, data, item, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              _context.p = 0;
              _context.n = 1;
              return getUnRead();
            case 1:
              res = _context.v;
              _res$data = res.data, code = _res$data.code, data = _res$data.data;
              if (code === 0 && !validateNull(data)) {
                item = data[0];
                $Bus.emit(SHOW_NOTIFY_EVENT, item);
              }
              _context.n = 3;
              break;
            case 2:
              _context.p = 2;
              _t = _context.v;
              (_t === null || _t === void 0 ? void 0 : _t.message) && MessagePlugin.warning(_t === null || _t === void 0 ? void 0 : _t.message);
            case 3:
              return _context.a(2);
          }
        }, _callee, null, [[0, 2]]);
      }));
      return function getUnReadRequset() {
        return _ref.apply(this, arguments);
      };
    }();
    return function (_ctx, _cache) {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("aside", _hoisted_2, [_createVNode(UserInfo), _createVNode(MessageNotice, {
        single: false
      })]), _createElementVNode("section", _hoisted_3, [_createVNode(AppList, {
        role: "manager"
      })])]);
    };
  }
};